import React, { useState } from "react";
import { useNavigate } from "react-router-dom"; // ADICIONE ESTA LINHA

import useAuth from "../../../../components/hooks/useAuth";
import Loader from "../../../../components/Loader";

const AddCampaignModalComponent = ({
  showModalAddCampaign,
  setShowModalAddCampaign,
}) => {
  // Sidebar começa fechada em qualquer resolução
  const [campaignName, setCampaignName] = useState("");
  const [campaignType, setCampaignType] = useState(1); // Adicione este estado
  const navigate = useNavigate(); // NOVO: hook para navegação
  const { sidebarOpen, getApi, postApi } = useAuth();

  const [loadingSave, setLoadingSave] = useState(false);

  // Função para fechar o modal
  const handleCloseModal = () => {
    setShowModalAddCampaign(false);
    setCampaignName(""); // Limpa o campo ao fechar
  };

  const handleCriarCampanha = async () => {
    if (!campaignName.trim()) {
      alert("Você precisa especificar um nome");
      return;
    }
    setLoadingSave(true);

    let response = await postApi("/api/v1/campaign/create", {
      name: campaignName,
      type_id: campaignType,
    });
    if (!response.id) {
      if (response.type_id) {
        alert(response.type_id.toString());
      } else if (response.name) {
        alert(response.name.toString());
      } else {
        alert(response.error.toString());
      }

      setLoadingSave(false);

      return;
    } else {
      let campaign = response;
      window.location.href = "/campanha/" + campaign.id;
    }

    setLoadingSave(false);
  };

  return (
    <div
      className="modal fade show"
      tabIndex="-1"
      style={{
        display: "block",
        background: "rgba(0,0,0,0.3)",
        zIndex: 2000,
      }}
    >
      <div
        className="modal-dialog"
        style={{ marginTop: window.HEADER_HEIGHT + 32 }} // Desce o modal abaixo do header
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Criar nova campanha</h5>
            <button
              type="button"
              className="btn-close"
              onClick={handleCloseModal}
            ></button>
          </div>
          <div className="modal-body">
            <div>
              <input
                type="text"
                className="form-control mb-3"
                placeholder="Nome da campanha"
                value={campaignName}
                onChange={(e) => setCampaignName(e.target.value)}
              />
              <select
                onChange={(e) => setCampaignType(e.target.value)}
                className="form-control"
                defaultValue="campanha"
                disabled
              >
                <option value="1">Campanha</option>
              </select>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn"
              style={{ background: "#005c53", color: "#fff" }}
              onClick={handleCloseModal}
            >
              Fechar
            </button>
            <button
              type="button"
              className="btn"
              style={{ background: "#005c53", color: "#fff" }}
              onClick={(e) => handleCriarCampanha()}
              disabled={!campaignName.trim() || loadingSave}
            >
              Criar campanha agora
            </button>
          </div>
          {loadingSave && <Loader />}
        </div>
      </div>
    </div>
  );
};

export default AddCampaignModalComponent;

<style>
  {`

/* --- Ajuste para o layout mobile quando o menu lateral está aberto --- */
@media (max-width: 768px) {
  .d-flex.flex-column.flex-shrink-0.text-white {
    position: fixed !important;
    left: 0 !important;
    top: 0 !important;
    height: 100vh !important;
    width: 56px !important;      /* Sempre mostra os ícones */
    min-width: 56px !important;
    max-width: 56px !important;
    overflow-x: hidden !important;
    z-index: 3000 !important;
    transition: width 0.3s !important;
    background: #277fa1 !important;
  }
  .d-flex.flex-column.flex-shrink-0.text-white.menu-aberto {
    width: 80vw !important;
    max-width: 260px !important;
    min-width: 56px !important;
    box-shadow: 4px 0 16px rgba(0,0,0,0.18) !important;
    z-index: 3000 !important;
  }
  .main-dashboard-content {
    margin-left: 0 !important;
    width: 100vw !important;
  }
}
`}
</style>;
